// Edit each paragraph and its mobile summary together. HTML links/emphasis are supported.
export const extracurricular = {
  "id": "panel-4",
  "type": "story",
  "title": "Extracurricular",
  "blocks": [
    {
      "heading": "Basketball",
      "desktop": "Outside of tech, I'm both a player and coach with the Edinburgh University Basketball Club. Coaching has strengthened my leadership, communication, and strategic planning. Skills that translate directly to computer science, especially when working in teams, adapting under pressure, and staying disciplined through intensive training and competition.",
      "mobile": "Playing and coaching with Edinburgh University Basketball Club has strengthened my leadership, communication and ability to adapt under pressure."
    },
    {
      "heading": "Hospitality",
      "desktop": "Alongside my studies, I've worked part-time at Ka Pao Edinburgh for three years, training in both front-of-house and bartending. The role sharpened my ability to multitask, communicate clearly, and stay calm under pressure. These skills carry directly into computer science, from team collaboration to debugging under tight deadlines.",
      "mobile": "Three years at Ka Pao Edinburgh, across front-of-house and bartending, developed my teamwork, multitasking and composure during busy shifts."
    }
  ],
  "images": [
    {
      "src": "./info_images/floorGeneral.jpeg",
      "alt": "Extracurricular Image 1",
      "caption": "Basketball scrimmage at Pleasance Gym, Edinburgh"
    },
    {
      "src": "./info_images/kaPaoTeam.jpeg",
      "alt": "Extracurricular Image 2",
      "caption": "Photo of the team at Ka Pao Edinburgh"
    }
  ],
  "videos": []
};
